<div class="gantt" [attr.id]="'gantt' + id">
    <!--span *ngFor="let item of [].constructor(255); let i = index" class="teamworkIcon">
        {{getChar(i)}}
    </span//-->
    <div [attr.id]="'workSpace' + id" style="padding:0px; overflow-y:auto; overflow-x:hidden;border:1px solid #e5e5e5;position:relative;margin:0 5px;">
        <div class="ganttButtonBar noprint">
            <div class="buttons">
                <ng-container *ngFor="let button of buttons">
                    <button *ngIf="!button.divider" (click)="button.onClick" [class]="'button textual icon ' + button.class" [title]="button.hint">
                        <span *ngIf="button.iconChar" [class]="button.icon">{{button.iconChar}}</span>
                        <i *ngIf="!button.iconChar" [class]="button.icon"></i>
                    </button>
                    <span *ngIf="button.divider" [class]="'ganttButtonSeparator ' + button.class"></span>
                </ng-container>
                <a href="https://gantt.twproject.com/" target="_blank" style="position:absolute;right:0px;"><img [src]="gb.getResourcePath('assets/gantt/res/twGanttLogo.png')" alt="Twproject" align="absmiddle" style="max-width: 100px; margin-top: 5px; padding-right: 15px"></a>
            </div>
        </div>
    </div>
    <gantt-templates [id]="id" [gantt]="this"></gantt-templates>
</div>
